import React, { useState } from 'react';

import FormGroupWrapper from '@/features/sampleDevelopment/components/SampleRequestModals/FormGroupWrapper';
import CustomDropdown from '@/components/CustomDropdown';
import InputField from '@/components/InputField';
import InputWrapper from '@/features/sampleDevelopment/components/SampleRequestModals/InputWrapper';
import {
	formatBrandOptions,
	formatProjectDealOptions,
	formatSampleTypeOptions
} from '@/features/sampleDevelopment/utils';
import { useGetProjectDealListQuery } from '@/features/sampleDevelopment/api/sampleDevelopmentApi';
import { checkAnyUserType, getUserInfo, isAdmin, isFashionDesigner } from '@/utils/Util';

const SendToPdForm = ({
	handleChange,
	requestValues,
	inputErrors,
	brands,
	sampleTypeList,
	selectedComment
}) => {
	const getUser = getUserInfo();
	const [selectedCustomer, setSelectedCustomer] = useState();
	const isOwner = parseInt(getUser?.id) === parseInt(selectedComment?.postedBy?.id);
	const isDisabledRequiredDate = selectedComment?.postedBy ? !(isAdmin() || isOwner) : false;
	const { data: projectDealList } = useGetProjectDealListQuery(
		{
			params: {
				brandId: selectedCustomer?.id
			}
		},
		{
			skip: !selectedCustomer?.id
		}
	);

	const selectedSampleType = requestValues?.sampleType?.value?.toLowerCase();
	const selectedCustomerName = (selectedCustomer?.name || requestValues?.primaryTargetCustomar?.name || '')
		.trim()
		.toLowerCase();
	const isNitexCustomer = selectedCustomerName === 'nitex';
	const isDealRequired =
		!isNitexCustomer &&
		(selectedSampleType === 'nitex development' || selectedSampleType === 'buyer development');

	return (
		<React.Fragment>
			<div className="flied-item d-grid grid-columns-3 gap-3">
				<FormGroupWrapper labelTitle="Primary target customer*">
					<CustomDropdown
						title="Select target customer"
						onItemClick={(value) => {
							setSelectedCustomer(value);
							handleChange('primaryTargetCustomar', value);
						}}
						selectedItem={selectedCustomer?.name || requestValues?.primaryTargetCustomar?.name}
						items={formatBrandOptions(brands)}
					/>
					{inputErrors?.primaryTargetCustomar && (
						<p className="error">{inputErrors?.primaryTargetCustomar}</p>
					)}
				</FormGroupWrapper>

				<FormGroupWrapper labelTitle="Sample type*">
					<CustomDropdown
						title="Select sample type"
						onItemClick={(value) => handleChange('sampleType', value)}
						selectedItem={requestValues?.sampleType?.value}
						items={formatSampleTypeOptions(sampleTypeList)}
					/>
					{inputErrors?.sampleType && <p className="error">{inputErrors?.sampleType}</p>}
				</FormGroupWrapper>

				<FormGroupWrapper labelTitle={`Deal${isDealRequired ? '*' : ''}`}>
					<div className={!selectedCustomer?.id ? 'cursor-none' : ''}>
						<CustomDropdown
							title="Select"
							onItemClick={(value) => handleChange('projectDealName', value)}
							selectedItem={
								requestValues?.projectDealName?.dealName ||
								requestValues?.projectDealName?.value
							}
							items={formatProjectDealOptions(projectDealList)}
							toolTipLength={25}
						/>
					</div>
					{inputErrors?.projectDealName && <p className="error">{inputErrors?.projectDealName}</p>}
				</FormGroupWrapper>
			</div>

			<div className={`flied-item d-grid grid-columns-2 gap-3`}>
				<InputWrapper labelTitle="Required date*">
					<InputField
						type="date"
						name="requiredDate"
						withWrapper={false}
						withLabel={false}
						value={requestValues?.requiredDate}
						onChangeHandler={(e) => handleChange('requiredDate', e.target.value)}
						errors={inputErrors?.requiredDate}
						disabled={isDisabledRequiredDate}
						className={`${isDisabledRequiredDate ? 'cursor-none' : ''}`}
					/>
				</InputWrapper>

				<InputWrapper
					labelTitle={`Expected Order Date${checkAnyUserType(['ACCOUNT_MANAGER']) ? '*' : ''}`}
				>
					<InputField
						type="date"
						name="expectedOrderDate"
						withWrapper={false}
						withLabel={false}
						value={requestValues?.expectedOrderDate}
						onChangeHandler={(e) => handleChange('expectedOrderDate', e.target.value)}
						disabled={
							isFashionDesigner() ||
							checkAnyUserType(['PRODUCT_DEVELOPMENT', 'GARMENTS_TECH', 'GRAPHICS_DESIGNER'])
						}
						className={`${isFashionDesigner() ? 'cursor-none' : ''}`}
						errors={inputErrors?.expectedOrderDate}
					/>
				</InputWrapper>
			</div>
		</React.Fragment>
	);
};

export default SendToPdForm;
